import React from 'react'

import { Dialog, DialogContent, IconButton, RadioGroup, FormControlLabel, Radio, DialogActions, Grid, Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import { mdiClose, mdiTruckDeliveryOutline } from '@mdi/js';
import Icon from '@mdi/react';
import theme from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cancelTitle: {
            fontSize: '18px',
            textAlign: 'center',
            fontWeight: 500,
            lineHeight: 2,
            marginBottom: theme.spacing(3),
        },
        actionsBox: {
            paddingTop: theme.spacing(2),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
        },
        editIcon: {
            textAlign: 'center',
            position: 'relative',
            paddingLeft: theme.spacing(8),
            marginBottom: theme.spacing(2),
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                height: '100px',
                borderRadius: '50%',
                opacity: '0.2',
                backgroundColor: theme.palette.blue.main,
            },
        },
        typeSection: {
            textAlign: 'center',
            marginBottom: theme.spacing(2),
            '& .MuiFormGroup-row': {
                justifyContent: 'space-around',
            },
        },
    })
);

const Select3plModal = (props: any) => {
    const classes = useStyles();
    const { open, onClose, value, onChange, data, onSubmit } = props
    return (
        <Dialog
            open={open}
            fullWidth
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogContent>
                <div
                    style={{
                        position: 'absolute',
                        left: '17px',
                        zIndex: 10,
                    }}
                >
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                    >
                        <Icon path={mdiClose} size={1} />
                    </IconButton>
                </div>
                <div className={classes.editIcon}>
                    <Icon
                        path={mdiTruckDeliveryOutline}
                        size={4}
                        color={theme.palette.orange.main}
                    />
                </div>

                <div className={classes.cancelTitle}>
                    لطفا سرویس مورد نظر خود را انتخاب کنید
                </div>

                <div className={classes.typeSection}>
                    <RadioGroup
                        row
                        aria-label="gender"
                        name="gender1"
                        value={value}
                        onChange={onChange}
                    >
                        {data?.filter(el => el.code !== "TAROFF").map((tpl: any) => {
                            return (
                                <FormControlLabel
                                    value={tpl.code}
                                    control={<Radio />}
                                    label={
                                        <img
                                            style={{ width: '50px', objectFit: 'contain' }}
                                            src={
                                                `/${tpl.code}.png`
                                            }
                                            alt={tpl.name}
                                        />
                                    }
                                />
                            );
                        })}
                    </RadioGroup>
                </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <Button
                            fullWidth
                            autoFocus
                            onClick={onClose}
                            variant="outlined"
                            size="large"
                        >
                            {`انصراف`}
                        </Button>
                    </Grid>
                    <Grid item xs={8}>
                        <Button
                            fullWidth
                            onClick={onSubmit}
                            variant="contained"
                            color="primary"
                            size="large"
                            disabled={!value}
                        >
                            {`تایید سرویس`}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default Select3plModal;